import { Import } from "iconsax-react";

interface ExportButtonProps {
  label: string;
  onClick?: () => void;
}

export const ExportButton = ({ label, onClick }: ExportButtonProps) => (
  <button
    onClick={onClick}
    className="px-5 py-1.5 bg-dark-10 text-dark-text hover:text-dark-white text-sm rounded-[5px] border border-dark-20 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex gap-2"
  >
    <Import size={20} color="#fff" />
    {label}
  </button>
);
